import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";

const FetchForeStreetKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplierdiscovery/kpi_page_data_fs`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_FORESTREET_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchForeStreetMainAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplierdiscovery/main_page_data_fs`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_FORESTREET_CARD_ACTION' }, data);
        dispatch(resData);
    }
}

export { FetchForeStreetKpiAction, FetchForeStreetMainAction }